import React, { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment-timezone";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import loadConfig from "../../Services/Api/ApiServices";

const DateInput = (props) => {
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [date, SetDate] = useState(
    props.date ? moment(props.date, "YYYY-MM-DD").toDate() : null
  );

  const dataJson = async () => {
    let jsonData = await loadConfig();
    let fieldsName = props.fieldsName;
    let code = jsonData[fieldsName];
    SetDataJsonObject(code);
  };

  useEffect(() => {
    dataJson();
  }, []);

  const datePickerRef = useRef(null);

  // Function to handle icon click
  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  // Update date if props.date changes
  useEffect(() => {
    if (props.date) {
      SetDate(moment(props.date, "YYYY-MM-DD").toDate());
    } else {
      SetDate(null);
    }
  }, [props.date]);

  return dataJsonObject ? (
    <>
      <div className="containerInputAHSF">
        <div className="label-container">
          <label
            htmlFor={dataJsonObject.code}
            title={
              props.lang == "ar" ? dataJsonObject.nameEN : dataJsonObject.nameAR
            }
            style={{ textAlign: props.lang !== "en" ? "right" : "left" }}
          >
            {props.lang !== "en"
              ? dataJsonObject.nameAR
              : dataJsonObject.nameEN}
            {dataJsonObject.isRequired ? <span>*</span> : ""}
          </label>
          <span>
            {props.showMassage ? (
              <p style={{ color: "red" }}>{props.massage}</p>
            ) : (
              ""
            )}
          </span>
          {props.showValidationMessage && (
            <span
              className="validation-icon"
              data-tooltip={props.validationMessage}
            >
              <FontAwesomeIcon icon={faCircleExclamation} />
              &nbsp;
            </span>
          )}
        </div>
        <DatePicker
          ref={datePickerRef}
          selected={date}
          placeholderText="dd/MM/yyyy"
          onChange={(e) => {
            SetDate(e);
            props.useFormat
              ? props.onChange(moment(e).format("YYYY-MM-DD"))
              : props.onChange(e);
          }}
          dateFormat="dd/MM/yyyy"
          minDate={
            new Date(
              dataJsonObject.startDateYear,
              dataJsonObject.startDateMonth,
              dataJsonObject.startDateDay
            )
          }
          maxDate={props.maxDate ? moment(props.maxDate).toDate() : null}
          scrollableYearDropdown
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          autoComplete="off"
          id={props.list ? dataJsonObject.code : "date-post"}
          disabled={props.disabled}
          filterDate={props.filterDate ? (date) => date.getDate() === 1 : ""}
          className={
            props.showValidationMessage
              ? "input-error date-input-with-icon"
              : "date-input-with-icon"
          }
          wrapperClassName={
            props.lang === "ar"
              ? "datepicker-wrapper-rtl"
              : "datepicker-wrapper-ltr"
          }
          showIcon={true}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-calendar3"
              viewBox="0 0 16 16"
              id="dateIcon"
              onClick={handleIconClick}
            >
              <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857z" />
              <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
            </svg>
          }
        />
      </div>
    </>
  ) : (
    ""
  );
};

export default DateInput;
